var ctaSlider = document.querySelectorAll('.cta-block-swiper');

var initSlider = (item) => {
  let options = {
    loop: false,
    iOSEdgeSwipeDetection: true,
    iOSEdgeSwipeThreshold: 0,
    simulateTouch: true,
    preventInteractionOnTransition: true,
    speed: 500,
    height: 'auto',
    initialSlide: 0,
    spaceBetween: 5,
    slidesPerView: 'auto',
  };

  var ctaSlider = new Swiper(item, options);
};

ctaSlider.forEach((item, i) => {
  let slider = false;
  function initSwiper() {
    var screenWidth = window.innerWidth;
    if (screenWidth >= 992 && slider) {
      slider.destroy(true, true);
      slider = false;
    } else if (screenWidth < 992 && !slider) {
      slider = initSlider(item);
    }
  }

  initSwiper();
  window.addEventListener('resize', initSwiper);
});
